import React, { useEffect, useState } from "react";
import { IAdjustmentTablesSearchParam } from "../../../Interfaces/deltaHedgeAdjustment";
import { getGroups } from "../../../Requests/optionDomain";
import SelectableButtons from "../../../Components/Dropdown/SelectableButtons";
import { DropdownItem } from "../../../Interfaces/dropdownInterfaces";
import { packetErrorHandler } from "../../../Utils/requestUtils";
import IncrementalOptionTable from "../../../Tables/OptionDomain/Custom/IncrementalOptionTable";
import DecrementalOptionTable from "../../../Tables/OptionDomain/Custom/DecrementalOptionTable";

// interface IProps {
//   searchParams: IAdjustmentTablesSearchParam;
// }

const CustomAdjustmentTablesWrapper = () => {
  const [searchParams, setSearchParam] = useState(
    {} as IAdjustmentTablesSearchParam
  );
  const [groups, setGroups] = useState([] as DropdownItem[]);

  useEffect(() => {
    getGroups()
      .then((resp) => {
        setGroups(resp);
        setSearchParam({ groupId: resp[0].id });
      })
      .catch(packetErrorHandler);
  }, []);

  const changeHandler = (name: string, value: any) => {
    setSearchParam({ ...searchParams, [name]: value });
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3 w-full px-5">
      <SelectableButtons
        label="گروه"
        name="groupId"
        options={groups}
        onChange={changeHandler}
        value={searchParams.groupId?.toString()}
        hideSelectAll
      />
      {searchParams.groupId ? (
        <>
          <div className="flex flex-col justify-start items-start gap-2">
            <div className="text-xs">تعدیل افزایشی</div>
            <IncrementalOptionTable searchParams={searchParams} />
            <div className="text-xs">تعدیل کاهشی</div>
            <DecrementalOptionTable searchParams={searchParams} />
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default CustomAdjustmentTablesWrapper;
